<template>
  <div class="container bg-white">
    <div  v-if="passed">
      <quiz-success :group="currentVideo.videoGroup"/>
    </div>

    <div class="d-flex fd-column QUIZ" v-else>
      <div class="TITLE">Pro Education</div>
      <div>
        <div class="QUIZ-TITLE">{{ quiz.title }} Quiz</div>
        <div class="ERROR" v-if="errors">Sorry, one or more of your answers was incorrect.
        You scored {{ score }}.
        You need 100% to pass. Please, try again.</div>
      </div>
      <div
          v-for="(question, index) in quiz.questions"
          :key="`question_${index}`"
          class="p-y-2 p-x-1">
        <div class="p-b-1 d-flex ">
          <div :class="{CIRCLE : !grades[index] && submitted}">
            <vk-icon
                :class="`${grades[index] ? 'c-green p-r-1' : 'c-white'}`"
                class="as-center jc-start"
                v-if="submitted"
                :name="`${grades[index] ? 'filled-check' : 'close'}`"
                :size="`${grades[index] ? 13 : 7}`"
            />
          </div>
        <span :class="{ERROR : !grades[index] && submitted}">{{ question.text }}</span></div>
        <div
            v-for=" (option) in question.options"
            :key="option.key"
            class="p-b-1 p-r-1"
            :class="{'CORRECT-INPUT' : grades[index]}"
        >
          <input
              class="m-r-1 RADIO-CHECK"
              type="radio"

              :disabled="submitted && disableSelection(option.key, index)"
              :name="`question_${index}_radio`"
              :id="`${index}-${option.key}`"
              :value="option.key"
              @change="handleSelection(index, option)"
          >
          <label
              :class="{'c-gray50': submitted && disableSelection(option.key, index)}"
              :for="`${index}-${option.key}`">
            {{ option.text }}
          </label>
        </div>
      </div>
      <div class="d-flex jc-center w-100 jc-start:mo m-l-1:mo">
        <button @click="goBack('rewatch button')" class="btn-secondary m-r-2">
          Go back to video
        </button>
        <button @click.prevent="submit" :disabled="disabled" class="btn">
          Submit
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import QuizSuccess from './components/QuizSuccess';

export default {
  name: 'education-quiz',
  components: {
    QuizSuccess,
  },
  data () {
    return {
      selectedOptions: {},
      show: false,
      grades: {},
      submitted: false,
      disabledOptions: {},
      attempts: 0,
      passed: false,
      corrections: 0,
    };
  },
  computed: {
    ...mapGetters('account/pro/education', ['currentVideo']),
    ...mapGetters('account/pro/info', ['serviceProviderId']),
    quiz () {
      return this.currentVideo.quiz;
    },
    disabled () {
      return this.quiz.questions.length !== Object.keys(this.selectedOptions).length
        || this.corrections > 0;
    },
    errors () {
      return this.submitted ? Object.values(this.grades).includes(false) : false;
    },
    score () {
      return `${Math.round((Object.values(this.grades).filter(value => value === true).length / Object.keys(this.grades).length) * 100)}%`;
    },
  },
  beforeRouteEnter (to, from, next) {
    if (!from.name) {
      next((vm) => {
        vm.$router.push({ name: 'dashboard::pro::education' });
      });
    }
    next();
  },
  mounted () {
    if (!this.quiz) {
      this.$router.push({ name: 'dashboard::pro::education' });
    }
    this.updateError(false);
  },
  methods: {
    ...mapActions('account/pro/education', ['fetchVideos', 'updateRecord', 'updateError']),

    handleSelection (question, answer) {
      this.$set(this.selectedOptions, question, answer.key);
      if (this.corrections > 0) {
        this.corrections -= 1;
      }
    },
    submit () {
      this.submitted = false;
      this.quiz.questions.forEach((question, index) => {
        this.$set(this.grades, index, question.key === this.selectedOptions[index]);
        if (!this.grades[index]) {
          this.$set(this.disabledOptions, index, this.selectedOptions[index]);
          this.corrections += 1;
          delete this.selectedOptions[index];
        }
      });
      this.submitted = true;
      const gradesArray = Object.values(this.grades);
      const correctPercent = Math.floor(
        (gradesArray.filter(Boolean).length / gradesArray.length) * 100);
      this.$events.$emit(this.$events.QUIZ_SUBMIT, {
        quizTitle: this.quiz.title,
        percent: correctPercent,
      });
      if (Object.values(this.grades).includes(false)) {
        this.attempts = this.attempts + 1;
        if (this.attempts >= this.quiz.retakes) {
          this.goBack('failed');
        }
      } else {
        this.success();
      }
    },
    success () {
      this.updateQuizRecord('passed');
      this.passed = true;
    },
    goBack (reason) {
      if (reason === 'failed') {
        this.updateError(true);
        this.updateQuizRecord('failed');
        this.$events.$emit(this.$events.QUIZ_FAILED, { quizTitle: this.quiz.title });
      } else {
        this.$events.$emit(this.$events.REWATCH_FROM_QUIZ, { quizTitle: this.quiz.title });
      }

      this.$router.replace({
        name: 'dashboard::pro::video',
        params: {
          videoId: this.currentVideo.videoId,
        },
      });
    },
    disableSelection (value, index) {
      return value === this.disabledOptions[index];
    },
    async updateQuizRecord (status) {
      await this.updateRecord({
        service_provider_education_quiz_id: this.currentVideo.serviceProviderEducationQuizId,
        serviceProviderId: this.serviceProviderId,
        videoId: this.currentVideo.videoId,
        status,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .TITLE {
    @include margin(4 0 2 1);
    @include h3();
    font-weight: 600;
    @include mobile-only {
      @include margin(2 0 1 1);
    }
  }
  .QUIZ-TITLE {
    @include margin(1 0 2 1);
    @include h4();
    font-weight: 600;
    @include mobile-only {
      @include margin(2 0 1 1);
    }
  }
  .CIRCLE {
    @include square(13px);
    border-radius: 50%;
    background-color:red;
    align-self: center;
    display: flex;
    justify-content: center;
    margin-right: $unit;
    flex-shrink: 0;
  }
  .ERROR {
    color: red;
  }
  .RADIO-CHECK {
    accent-color:$color-depot;
  }
  .CORRECT-INPUT {
    pointer-events: none;
  }
  .QUIZ {
    padding-bottom: 10%;
  }
</style>
